import { GridColDef } from '@mui/x-data-grid';
import stringUtils from './stringUtils';

interface RecordData {
  [key: string]: any;
}

const mergeColumns = (
  fixedColumns: GridColDef[],
  dynamicColumns: GridColDef[]
): GridColDef[] => {
  const fixedFields = new Set(
    fixedColumns.map((col) => col.field.toLowerCase())
  );

  const uniqueDynamicColumns = dynamicColumns.filter(
    (col) => !fixedFields.has(col.field.toLowerCase())
  );

  return [...fixedColumns, ...uniqueDynamicColumns];
};

const extractUniqueKeys = (data: RecordData[]): string[] => {
  const allKeys = data.flatMap(Object.keys);
  return Array.from(new Set(allKeys));
};

const createColumnsFromKeys = (keys: string[]): GridColDef[] => {
  const displayKeys = keys.filter((k) => k.toLowerCase() !== 'id');
  return displayKeys.map((key) => ({
    field: key,
    headerName: stringUtils.formatStringToReadAbleText(key),
    minWidth: 220,
    flex: 1
  }));
};

const getColumnsToDisplay = (dynamicColumns: GridColDef[]): GridColDef[] => {
  return dynamicColumns.length > 0
    ? dynamicColumns
    : [{ field: 'noData', headerName: '', flex: 1, sortable: false }];
};

const DATA_GRID_INITIAL_STATE = {
  pagination: { paginationModel: { pageSize: 10, page: 0 } }
};

const PAGE_SIZE_OPTIONS = [5, 10, 25];

const tableColumnUtils = {
  mergeColumns,
  extractUniqueKeys,
  createColumnsFromKeys,
  getColumnsToDisplay,
  DATA_GRID_INITIAL_STATE,
  PAGE_SIZE_OPTIONS
};

export default tableColumnUtils;
